import { render, staticRenderFns } from "./CompareContainer.vue?vue&type=template&id=73022c1b&"
import script from "./CompareContainer.vue?vue&type=script&lang=js&"
export * from "./CompareContainer.vue?vue&type=script&lang=js&"
import style0 from "./CompareContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports